import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
} from '@angular/core';
import { FileUtilities } from '@shared/ui-components/au-file-loader/helpers/file-utilities';
import { fileTypesConfig } from '@shared/ui-components/au-file-loader/au-file-loader.config';
import {
	IDroppedFile,
	IFileTypeConfig,
} from '@shared/ui-components/au-file-loader/au-file-loader.interfaces';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'au-file-name',
	templateUrl: './au-file-name.component.html',
	styleUrls: ['./au-file-name.component.scss'],
	imports: [MatIcon],
})
export class AuFileNameComponent implements OnChanges {
	@Input() fileTypesConfig: IFileTypeConfig = fileTypesConfig;
	@Input() name: string;
	@Input({ required: true }) fileData: Partial<IDroppedFile>;
	@Output() openFile = new EventEmitter<number>();

	icon: string;

	fileUtilities: FileUtilities;

	constructor() {
		this.fileUtilities = new FileUtilities(fileTypesConfig);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.fileTypesConfig?.currentValue) {
			this.fileUtilities = new FileUtilities(changes.fileTypesConfig?.currentValue);
		}

		if (changes.fileData) {
			this.icon = this.getIcon();
		}
	}

	private getIcon(): string {
		if (!this.fileData) {
			return;
		}

		const type = this.fileUtilities.getFileType(
			this.fileData.name,
			this.fileData.contentType
		);

		if (type === 'file-unknown') {
			return type;
		}

		return this.fileTypesConfig[type].icon;
	}

	open() {
		this.openFile.emit();
	}

	hasError(): boolean {
		if (this.fileData?.errors) {
			return Object.keys(this.fileData?.errors)?.length > 0;
		}

		return false;
	}
}
